const namespace = 'str/user/';

const userActionNames = {
  USER_SUCCESS: `${namespace}USER_SUCCESS`,
  USER_RESET: `${namespace}USER_RESET`,
  USER_UPDATE: `${namespace}USER_UPDATE`,
  USER_FETCH: `${namespace}USER_FETCH`,
  USER_SET_SUBSCRIPTION_ACTIVE: `${namespace}USER_SET_SUBSCRIPTION_ACTIVE`,
  USER_DELETE: `${namespace}USER_DELETE`,
  USER_LIBRARY: `${namespace}USER_LIBRARY`,
  USER_LIBRARY_RESET: `${namespace}USER_LIBRARY_RESET`,
  USER_LIBRARY_SUCCESS: `${namespace}USER_LIBRARY_SUCCESS`,
  USER_NEW_SONGS_IN_LIBRARY_FLAG_RESET: `${namespace}USER_NEW_SONGS_IN_LIBRARY_FLAG_RESET`,
  USER_SET_SONG_LIST_POSITION: `${namespace}USER_SET_SONG_LIST_POSITION`,
  USER_DOWNLOAD_SONG_SUCCESS: `${namespace}USER_DOWNLOAD_SONG_SUCCESS`,
  DECREASE_AVAILABLE_AI_GENERATIONS: `${namespace}DECREASE_AVAILABLE_AI_GENERATIONS`,
};

export default userActionNames;
